import { GenericLayout } from '@/components/layouts/GenericLayout/GenericLayout';
import { Spinner } from '@/components/ui/Spinner/Spinner';

export const FullPageSpinner = ({ label }: { label?: string }) => {
  return (
    <GenericLayout className='bg-fill-background-neutral!' mainProps={{ className: 'justify-center' }}>
      <div className='-mt-[76px] flex flex-col items-center justify-center gap-4' role='status' aria-live='polite'>
        <Spinner className='size-16 stroke-1' />
        {label && <span className='text-center'>{label}</span>}
      </div>
    </GenericLayout>
  );
};
